import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { SERVICE_ENDPOINT } from '../../constants';
import {
  CheckIpResponse,
  GetAgencyContact,
  GetSelfInfoResponse,
  GetStaticContentRequest,
  MyBPaymentMethodResponse,
} from '../../models/api/common';
import { BaseResponseWithData } from '../../models/api';

@Injectable({
  providedIn: 'root',
})
export class CommonHttpService {
  private _http = inject(HttpClient);

  getSelfInfo() {
    return this._http.get<GetSelfInfoResponse>(SERVICE_ENDPOINT.getSelfInfo);
  }

  getContact(domain: string, agCode: string) {
    return this._http.get<GetAgencyContact>(
      `${SERVICE_ENDPOINT.getContact}?domain=${domain}&agCode=${agCode}`,
    );
  }

  getContentPayment(request: GetStaticContentRequest) {
    return this._http.post<BaseResponseWithData<MyBPaymentMethodResponse>>(
      `${SERVICE_ENDPOINT.getContentPayment}`,
      request,
    );
  }

  checkIp() {
    return this._http.get<CheckIpResponse>(`${SERVICE_ENDPOINT.checkIp}`);
  }

  getIpAddress() {
    return this._http.get<string>(`https://dotmaui.com/my-ip/raw`);
  }
}
